import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js"; // Importera CryptoJS
import Navbar from "../../components/layout/Navbar";


/**
 * React component for Signing in.
 * @returns {JSX.Element}
 * @constructor
 */

export default function SignInSide() {
    const history = useHistory();
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const secretKey = "din-hemliga-nyckel"; // Ändra detta till en säker nyckel

    // Funktion för att kryptera cookies
    const encryptCookie = (value) => {
        return CryptoJS.AES.encrypt(value, secretKey).toString();
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        const data = new FormData(event.currentTarget);
        const user = {
            email: data.get("email"),
            password: data.get("password"),
        };
        //const token = await getToken();
        try {
            
            // ------------ NEDAN ÄR MOCK TESTING


            // TEMPORARY LOCAL ADMIN LOGIN
            // Checking to match the temporary admin account!!!! from .env file
            const tempAdminEmail = process.env.REACT_APP_TEMP_ADMIN_EMAIL;
            const tempAdminPassword = process.env.REACT_APP_TEMP_ADMIN_PASSWORD;
            
            if (tempAdminEmail && tempAdminPassword && 
                user.email === tempAdminEmail && user.password === tempAdminPassword) {
                // Temporary admin login
                await new Promise(resolve => setTimeout(resolve, 500)); // Short delay
                
                localStorage.setItem("email", user.email);
                const encryptedValue = encryptCookie("ADMIN");
                Cookies.set("access", encryptedValue, { secure: true, sameSite: "Strict" });
                history.push("/admin");
                return;
            }

            // MOCK LOGIN FOR TESTING
            // If email starts with "mock" fake simulate a successful login without backend
            if (user.email.toLowerCase().startsWith("mock")) {
                // Mock login
                await new Promise(resolve => setTimeout(resolve, 2000)); // Simulate 2s network delay to mimic how it would be in real login
                
                localStorage.setItem("email", user.email);
                const encryptedValue = encryptCookie("USER");
                Cookies.set("access", encryptedValue, { secure: true, sameSite: "Strict" });
                history.push("/"); // Redirect to root instead of /home
                return;
            }


            // ------------ OVAN ÄR MOCK TESTING


            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify(user),
            });

            if (!response.ok) {
                const errorText = await response.text();
                setErrorMessage("Felaktig E-postadress eller Lösenord, vänligen försök igen");
                setIsLoading(false);
                throw new Error(`Login failed: ${errorText}`);
            }

            const result = await response.json();

            if (result.role === "ADMIN") {
                localStorage.setItem("userId", result.user_id);
                localStorage.setItem("token", result.token);
                localStorage.setItem("role", result.role)
                const encryptedValue = encryptCookie("ADMIN");
                Cookies.set("access", encryptedValue, { secure: true, sameSite: "Strict" });
                history.push("/admin");
            }
            else if (result.role === "LOCALADMIN"){
                localStorage.setItem("userId", result.user_id);
                localStorage.setItem("token", result.token);
                localStorage.setItem("role", result.role)
                const encryptedValue = encryptCookie("LOCALADMIN");
                Cookies.set("access", encryptedValue, { secure: true, sameSite: "Strict" });
                history.push("/admin");
            }
            else {

                //TODO email and user ID should probably not be 
                localStorage.setItem("email", data.get("email"));
                localStorage.setItem("token", result.token);
                localStorage.setItem("userId", result.user_id);
                const encryptedValue = encryptCookie("USER");
                Cookies.set("access", encryptedValue, { secure: true, sameSite: "Strict" });
                history.push("/"); // Redirect to root "/" (start page for users)
            }
        } catch (error) {
            console.error(error);
            setErrorMessage("Felaktig E-postadress eller Lösenord, vänligen försök igen");
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-sage font-body pt-16">

            <Navbar />
            
            <div className="flex items-center justify-center min-h-[calc(100vh-4rem)] p-4">
                <div className="w-full md:max-w-md bg-offwhite md:shadow-lg md:rounded-lg overflow-hidden">
                
                {/* Form Section */}
                <div className="w-full bg-offwhite flex items-center justify-center">
                    <div className="w-full max-w-md px-6 py-8">
                        <div className="flex flex-col items-center">
                            {/* Lock Icon */}
                            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-forest mb-4">
                                <svg className="w-6 h-6 text-offwhite" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                </svg>
                            </div>
                            
                            <h1 className="text-2xl font-heading font-semibold text-charcoal mb-6">
                                Logga In
                            </h1>
                            
                            <form onSubmit={handleSubmit} className="w-full mt-4">
                                <div className="mb-4">
                                    <label htmlFor="email" className="block text-sm font-medium text-charcoal mb-1">
                                        E-postadress *
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        autoComplete="email"
                                        required
                                        autoFocus
                                        className="w-full px-3 py-2 border border-sage bg-white rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-forest focus:border-forest bg-offwhite"
                                    />
                                </div>
                                
                                <div className="mb-4">
                                    <label htmlFor="password" className="block text-sm font-medium text-charcoal mb-1">
                                        Lösenord *
                                    </label>
                                    <input
                                        type="password"
                                        id="password"
                                        name="password"
                                        autoComplete="current-password"
                                        required
                                        className="w-full px-3 py-2 border border-sage bg-white rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-forest focus:border-forest bg-offwhite"
                                    />
                                </div>
                                
                                {errorMessage && (
                                    <p className="text-red-600 text-sm mb-4">
                                        {errorMessage}
                                    </p>
                                )}
                                
                                <button
                                    type="submit"
                                    disabled={isLoading}
                                    className={`w-full bg-leaf text-offwhite py-2 px-4 rounded-md hover:bg-forest transition-colors duration-200 mt-6 mb-4 font-medium ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                                >
                                    {isLoading ? "Loggar in..." : "Logga In"}
                                </button>
                                
                                <div className="flex justify-between items-center text-sm">
                                    <a href="/ForgotPassword" className="text-leaf hover:text-forest hover:underline">
                                        Glömt Lösenord?
                                    </a>
                                    <a href="/SignUp" className="text-leaf hover:text-forest hover:underline">
                                        Inget konto än? Registrera dig
                                    </a>
                                </div>
                            </form>

                            <div className="mt-8 pt-8 text-center w-full border-t border-sage">
                                <p className="text-sm text-brown">
                                    &copy; {new Date().getFullYear()} Naturborgarmärket
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
}
